// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-app-bar.theme--light[data-v-29646038],.v-card.theme--light[data-v-29646038]{background-color:#fff!important}.v-card.theme--light .v-card__text[data-v-29646038]{color:rgba(0,0,0,.87)}.v-card.theme--dark[data-v-29646038]{background-color:#fff!important}.caption[data-v-29646038]{text-transform:uppercase}.body-1[data-v-29646038]{font-weight:500}", ""]);
// Exports
module.exports = exports;
